import Layout from "../Layout";
import Phone from '../../assets/icons/Phone.svg'
import Email from '../../assets/icons/Email.svg'
import './contact.scss';
const Mentions = () => {
  return (
    <Layout>
      <div className="container min-vh-100 mt-32">
      
      </div>
    </Layout>
  );
};
export default Mentions;
